/* eslint-disable camelcase */
import { APIMemberData } from "@companion-core/shared/app/Interfaces/API";

export const formatPayload = (
  formPayload: Record<string, unknown>,
  dataMember?: APIMemberData | null
) => {
  const { firstname, lastname, personal_email, professional_email, subscriptions } =
    dataMember || {};
  const { subject, subscription_external_id } = formPayload;
  const email = personal_email ?? professional_email ?? "";
  const activeSubscription = subscriptions?.find(
    (subscription) => subscription.status.toLowerCase() === "active" && subscription.is_primary
  );
  return {
    email,
    firstname,
    lastname,
    specifics: {
      family: "Member-relationship",
      subfamily: subject,
      subscription_external_id: subscription_external_id ?? activeSubscription?.external_id,
    },
    ...formPayload,
  };
};
